// @ts-strict-ignore
import {BaseClient} from 'common/report/queries/utils/base-client';

import {queryApiUrl} from '../utils';
import {ExperimentQueryParams} from './types';

class ExperimentsClient extends BaseClient {
  public buildEndpoint({isSegmentsQuery}) {
    if (isSegmentsQuery) {
      return queryApiUrl(`experiments/segments/`);
    }
    return queryApiUrl(`experiments/`);
  }

  public buildQueryParams(params: ExperimentQueryParams) {
    return {
      project_id: params.projectId,
      ...(params.workspaceId ? {workspace_id: params.workspaceId} : {}),
    };
  }

  // params argument is declared optional to avoid conflicting with BaseClient's Javascript no-argument function declaration
  public buildRequestBody(params?: ExperimentQueryParams) {
    if (params.isSegmentsQuery === true) {
      // as silly as this looks, it's needed to trigger typescript's discriminant property check
      return JSON.stringify({
        bookmark_id: params.bookmarkId,
        date_range_override: params.dateRangeOverride,
        ...(params.segmentedOverride ? {segmented_override: params.segmentedOverride} : {}),
        trend_unit: params.trendUnit,
        tracking_props: params.trackingProps,
      });
    } else {
      return JSON.stringify({
        bookmark_id: params.bookmarkId,
        control: params.control,
        treatments: params.treatments,
        date_range_override: params.dateRangeOverride,
        trend_unit: params.trendUnit,
        segment: params.segment,
        ...(params.segmentedOverride ? {segmented_override: params.segmentedOverride} : {}),
        tracking_props: params.trackingProps,
      });
    }
  }

  public processResponse(response) {
    return response;
  }
}

export const experimentsClient = new ExperimentsClient();
